import {Fragment, useState, useEffect} from 'react';

import {MegaMenu} from 'primereact/megamenu';

import {InvoiceSynthesizePetrolReportService as Service} from './InvoiceSynthesizePetrolReportService';
import {AppStorage} from '../../../service/UserStorage';
import {Filter} from '../filter-petrol';
import {FormatDisplay} from '../../../shared/format';


export default function TongHopHoaDon() {

  const [displayFilter, setDisplayFilter] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [requiredParams, setRequiredParams] = useState(null);
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState({});
  const search = (params) => {
    params.userName = AppStorage.get('UserName');
    setFilter(params);
    setDisplayFilter(false);

    Service.getList(params).then(data => {
      console.log(data);
      setItems(data);
    });
  }
  const downloadExcel = () => {
    Service.downloadExcel({
      ...filter,
      userName: AppStorage.get('UserName')
      }).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao_cao_xang_dau_mau_cqt.xlsx`;
      link.click();
    });
  }
  const actions = [
    {label: 'Lọc dữ liệu', icon: 'pi pi-fw pi-filter', className: 'iam-toolbar iam-toolbar-secondary', command: () => setDisplayFilter(true)},
    {label: 'Kết xuất excel', icon: 'pi pi-fw pi-file-excel', className: 'iam-toolbar iam-toolbar-secondary', command: downloadExcel}
  ];

  return (
    <Fragment>
      <MegaMenu model={actions}/>
      <Filter header="Báo cáo xăng dầu theo mẫu CQT" display={displayFilter} setDisplay={setDisplayFilter} search={search}
              />

      <div className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines p-datatable-sm">
        <div className="p-datatable-wrapper">
          <table className="p-datatable-table">
            <colgroup>
              <col style={{width: '50px'}}/>
              <col style={{minWidth: '250px'}}/>
              <col style={{minWidth: '150px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '100px'}}/>
              <col style={{minWidth: '150px'}}/>
              <col style={{minWidth: '150px'}}/>
              <col style={{minWidth: '150px'}}/>
            </colgroup>
            <thead className="p-datatable-thead">
            <tr role="row">
              <th rowSpan={2} role="columnheader" className="justify-content-center">
                <div className="p-column-header-content"><span className="p-column-title">#</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Số CHXD</span></div>
              </th>
              <th rowSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Số cột bơm</span></div>
              </th>
              <th colSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Số lượng xuất bán</span></div>
              </th>
              <th colSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Số lượng hóa đơn phát hành</span></div>
              </th>
              <th colSpan={2} role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Doanh thu bán hàng đối với mặt hàng xăng dầu</span></div>
              </th>
            </tr>
            <tr role="row">
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Trong đó: Bán lẻ cho khách hàng</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Trong đó: Bán lẻ cho khách hàng</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Tổng số</span></div>
              </th>
              <th role="columnheader">
                <div className="p-column-header-content"><span className="p-column-title">Trong đó: Bán lẻ cho khách hàng</span></div>
              </th>
            </tr>
            </thead>
            <tbody className="p-datatable-tbody">
            {items?.map((item, index) => <tr key={index}>
              <td className="text-center">{(index + 1)}</td>
              <td className="text-left">{item.storeName}</td>
              <td className="text-left">{item.deviceName}</td>
              <td className="text-center">{FormatDisplay.number(item.totalOut)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalOutRetail)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalInvoice)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalInvoiceRetail)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalAmount)}</td>
              <td className="text-center">{FormatDisplay.number(item.totalAmountRetail)}</td>
            </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
}